<template>
	<div class='login-wrap'>
		<div class="logo-wrap">
			<div class="flex flex-row-start" @click="goIndex"><img src="@/static/images/top-logo.png" alt=""></div>
		</div>
		<div class=" flex flex-row-center form-wrap" :style="{'backgroundImage': 'url('+bg+')'}">
			<div class="form-box">
				<div class="form-title">密码找回</div>
				<el-form :model="formData" :rules="rules" label-position="top" ref="loginFormRef">

					<el-form-item label="" prop="imageCaptcha" class="code-item">
						<div class="flex flex-row-between">
							<el-input v-model="formData.imageCaptcha" placeholder="图像验证码"></el-input>
							<el-image :src="imageCode" @click="getCaptchaImgHandle"></el-image>
						</div>
					</el-form-item>
					<el-form-item label="" prop="mobile">
						<el-input v-model="formData.mobile" placeholder="手机号码">
						</el-input>
					</el-form-item>
					<el-form-item label="" prop="code" class="code-item">
						<div class="flex flex-row-between">
							<el-input v-model="formData.code" placeholder="手机验证码"></el-input>
							<el-button type="primary" :disabled="!codeTag" @click="sendHandler">{{codeTag?'获取验证码':second+'s后可重新获取'}}</el-button>
						</div>
					</el-form-item>
					<el-form-item label="" prop="password">
						<el-input type="password" v-model="formData.password" placeholder="密码，6~20位">
						</el-input>
					</el-form-item>
					<el-form-item label="" prop="confirmPassword">
						<el-input type="password" v-model="formData.confirmPassword" placeholder="重复密码">
						</el-input>
					</el-form-item>
					<!--
					<el-form-item class="check-item" prop="agree">
						<div class="flex flex-row-start">
							<el-checkbox v-model="formData.agree" label="点击同意"></el-checkbox>
							<router-link class="link" to="/netapplication">《肥城信用网站服务协议》</router-link>
						</div>
					</el-form-item> -->
					<el-form-item>
						<el-button class="login-button" type="primary" @click="submitHandler">提交</el-button>
					</el-form-item>
					<div class="flex flex-row-end">
						<router-link class="register-link" to="/login"><span>返回登录</span></router-link>
					</div>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
import { getCaptchaSms, forgetPw } from '@/api';
import { v4 as uuidv4 } from 'uuid';
import BASE_URL from '@/api/base.js'

export default {
	components: {},
	data() {
		const validatePassword = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入密码'));
			} else if (value !== this.formData.password) {
				callback(new Error('两次密码输入不一致'))
			}
			callback()
		}
		return {
			bg: require('@/static/images/login/bg.png'),
			formData: {
				mobile: undefined,
				password: undefined,
				code: undefined,
				imageCaptcha: undefined,
				confirmPassword: undefined
			},
			rules: {
				mobile: [
					{ required: true, message: '请输入手机号码' },
				],
				password: [
					{ required: true, message: '请输入密码' },
				],
				// agree: [{ required: true, message: '请阅读并选择同意网站协议' }],
				code: [{ required: true, message: '请输入验证码' }],
				imageCaptcha: [{ required: true, message: '请输入图片验证码' }],
				confirmPassword: { validator: validatePassword }
			},
			codeTag: true,
			second: 60,
			timer: undefined,
			imageCode: undefined
		};
	},
	computed: {},
	watch: {},


	methods: {
         goIndex(){
            this.$router.push('/')
        },
		getCaptchaImgHandle() {
			let uuid = uuidv4();
			this.uuid = uuid;
			this.imageCode = BASE_URL + `/api/captcha/image?token=${this.uuid}`
		},
		sendHandler() {
			if (!this.codeTag) {
				return;
			}
			const { mobile, imageCaptcha } = this.formData;
			if (!mobile) {
				this.$message({
					message: '请输入手机号码',
					type: 'warning'
				});
				return;
			}
			if (!imageCaptcha) {
				this.$message({
					message: '请输入图片验证码',
					type: 'warning'
				});
				return;
			}
			this.$set(this, 'codeTag', false)
			getCaptchaSms({ mobile, imageCaptcha: imageCaptcha, token: this.uuid, imageToken: this.uuid }).then(res => {
				this.$set(this, 'codeTag', false)
				this.timer = setInterval(this.doLoop, 1000);
			}).catch(() => {
				if (this.timer) {
					clearInterval(this.timer);
				}
				this.$set(this, 'codeTag', true);
				this.$set(this, 'second', 60)
			})
		},

		doLoop() {
			this.second--;
			if (this.second === 0) {
				clearInterval(this.timer);
				this.$set(this, 'codeTag', true);
				this.$set(this, 'second', 60)
			}
		},
		submitHandler() {
			this.$refs['loginFormRef'].validate((valid) => {
				if (valid) {
					const { mobile, code, password, confirmPassword } = this.formData;
					const formData = {
                        mobile: mobile,
                        smsToken: this.uuid,
                        smsCaptcha: code,
                        newPassword: password,
                        rePassword: confirmPassword
                    };
					forgetPw(formData).then((res) => {
                        this.$refs['loginFormRef'].resetFields();
						this.$router.replace('/login');
					});
				} else {
					return false;
				}
			});
		},
	},
	created() { },
	mounted() {
		this.getCaptchaImgHandle();
	},
};
</script>
<style lang='scss'>
	@import './login.scss';
	.form-box {
		height: auto !important ;
		padding-bottom: 15px !important;
		.check-item {
			.el-form-item__content {
				justify-content: flex-start;
				.link {
					color: $red;
				}
			}
		}
		.el-input__inner {
			border: 1px solid #efefef !important;
			border-radius: 3px;
		}
		.code-item {
			.el-button {
				margin-left: 15px;
				height: 38px;
				background-color: $red;
				border-color: $red;
			}
			.el-image {
				width: 90px;
				height: 38px;
				margin-left: 15px;
				cursor: pointer;
				display: block;
				flex-shrink: 0;
				.el-image__inner {
					width: 90px;
				}
			}
		}
		.login-button {
			margin-top: 0 !important;
		}
	}
</style>
